<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="70%"
    top="5vh"
    :before-close="handleClose"
    custom-class="privacy-dialog"
  >
    <div class="pass-rule-box">
      <div class="rule-title">
        <h3>隐私政策</h3>
        <el-button class="btn-close" @click="closeDialog" circle icon="el-icon-close"></el-button>
      </div>
      <div class="rule-nr">
        <p>
          本站（以下亦称"我们"）深知个人信息对您的重要性，我们尊重并保护所有使用我们平台服务的用户的个人信息，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品（或服务）前，仔细阅读并了解本《我们隐私政策》（下称"本隐私政策"）。
        </p>
        <p>&nbsp;</p>
        <p>一、我们处理个人信息的法律依据</p>
        <p>
          本隐私政策制定的法律依据为《中华人民共和国消费者权益保护法》、《中华人民共和国网络安全法》、《中华人民共和国电子商务法》、《信息安全技术个人信息安全规范》以及其他涉及公民个人信息的相关法律法规。通常，我们会基于本隐私政策提示的功能收集您的个人信息。某些情况下，如果涉及其他信息的收集我们会单独向您出示个人信息保护说明条款。
        </p>
        <!-- 其他隐私政策内容保持不变 -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PrivacyDialog',
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>

<style scoped>
.pass-rule-box {
  padding: 20px;
}
.rule-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.rule-title h3 {
  font-size: 18px;
  color: #333;
}
.btn-close {
  border: none;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
}
.rule-nr {
  max-height: 60vh;
  overflow-y: auto;
  line-height: 1.6;
}
.rule-nr p, .rule-nr ol, .rule-nr ul {
  margin-bottom: 10px;
}
.rule-nr ol, .rule-nr ul {
  padding-left: 20px;
}
</style>